module.exports = __webpack_public_path__ + "img/header.882e89f8.svg";